import { useState } from 'react'
import { DetailsList, DetailsListLayoutMode, SelectionMode, Text } from '@fluentui/react'
import { CostBasis, SlowestAnswerItem } from '../../api/models'
import ConversationModal from '../conversations/ConversationModal'
import { useConversationById } from '../conversations/useConversationById'
import PerformancePanel from './PerformancePanel'
import { buildAnswerColumns } from './answerColumns'

type SlowestAnswersTableProps = {
  items: SlowestAnswerItem[]
  costBasis: CostBasis
}

const SlowestAnswersTable = ({ items, costBasis }: SlowestAnswersTableProps) => {
  const [openConversationId, setOpenConversationId] = useState<string | null>(null)
  const modalContent = useConversationById(openConversationId)

  return (
    <PerformancePanel
      title="Slowest answers"
      isEmpty={items.length === 0}
      emptyMessage="No completed answers recorded for this period."
    >
      <Text variant="small" styles={{ root: { color: '#605e5c' } }}>
        Abandoned answers are excluded.
      </Text>
      <div style={{ overflowX: 'auto' }}>
        <DetailsList
          items={items}
          columns={buildAnswerColumns({ costBasis, onOpenConversation: setOpenConversationId })}
          getKey={(item: SlowestAnswerItem) => item.telemetry_id.toString()}
          selectionMode={SelectionMode.none}
          layoutMode={DetailsListLayoutMode.justified}
          ariaLabelForGrid="Slowest answers"
          onShouldVirtualize={() => false}
        />
      </div>
      <ConversationModal content={modalContent} onDismiss={() => setOpenConversationId(null)} />
    </PerformancePanel>
  )
}

export default SlowestAnswersTable
